import { Badge } from '@/components/ui/Badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/Popover';
import { FlagCallout } from '@/components/flags/FlagCallout';
import { flagBadgeLabel, highestFlagSeverity } from '@/utils/automationFlags';
import type { AutomationFlag } from '@/types/automationFlags';

export function FlagBadge({ flags }: { flags: AutomationFlag[] }) {
  const severity = highestFlagSeverity(flags);
  if (!severity || severity === 'info') return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex"
          aria-label={flagBadgeLabel(severity)}
          onClick={(event) => event.stopPropagation()}
        >
          <Badge variant={severity === 'error' ? 'danger' : 'warning'} className="normal-case tracking-normal">
            {flagBadgeLabel(severity)}
          </Badge>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[min(24rem,calc(100vw-2rem))] p-3">
        <FlagCallout flags={flags} />
      </PopoverContent>
    </Popover>
  );
}
